import protocol from './protocol'
import report from './report'

export default [
  ...protocol,
  ...report,
]
